import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "./shared.module";
import { BadgeEstadosComprobanteComponent } from "../component/badge-estados-comprobante/badge-estados-comprobante.component";
import { BadgeEstadosContratoComponent } from "../component/badge-estados-contrato/badge-estados-contrato.component";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
  ],
  declarations: [
    BadgeEstadosComprobanteComponent,
    BadgeEstadosContratoComponent
  ],
  exports: [
    BadgeEstadosComprobanteComponent,
    BadgeEstadosContratoComponent
  ],
  providers: [
  ],
})

export class ComponentesGenericosModule { }
